import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 48 48"
            //enableBackground="new 0 0 48 48"
            xmlSpace="preserve"
        >
            <polyline
                points="34.5,3 13.5,24 34.5,45 "
                fill="transparent"
                stroke="#b3b3b3"
                strokeWidth={"1.75"}
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export default React.memo(ChevronLeft);
